import ShopPaymentForm from './ShopPaymentForm';
import {
  Heading,
  HeadingDescription,
  HeadingTitle,
  ShopTermsCard
} from '../ShopTerms.styles';

const ShopPayment = () => {
  return (
    <ShopTermsCard>
      <Heading>
        <HeadingTitle>Shop by payment</HeadingTitle>
        <HeadingDescription>
          Create your budget and start searching
        </HeadingDescription>
      </Heading>
      <ShopPaymentForm />
    </ShopTermsCard>
  );
};

export default ShopPayment;
